type TreeNode = {
  id: string;
  label: string;
  documentCount?: number;
  children?: TreeNode[];
  [key: string]: any;
};

export const PROTOCOL_INTELLIGENCE_ROUTE = '/AI/Review/ProtocolIntelligence';

export const getNonEmptyText = (
  value: string | null | undefined
): string | undefined =>
  typeof value === 'string' && value.trim().length > 0 ? value : undefined;

export const transformTreeData = (nodes: TreeNode[]): TreeNode[] => {
  return nodes.map((node) => {
    const hasChildren = node.children && node.children.length > 0;
    const count = node.documentCount ?? 0;

    return {
      ...node,
      ...(hasChildren ? {skipParent: true} : {}),
      ...(count < 1 || count >= 250 ? {disabled: true} : {}),
      children: hasChildren ? transformTreeData(node.children!) : [],
    };
  });
};

/**
 * Converts an uppercase string to capitalized format
 * (first letter uppercase, rest lowercase).
 *
 * @param value Uppercase string (e.g., 'DRAFTED')
 * @returns Capitalized string (e.g., 'Drafted')
 */
export function toCapitalized(value: unknown): string {
  if (typeof value !== 'string') return '';

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export const RELEVANCY_COLUMN_MAP: Record<string, string> = {
  docId: 'DocId',
  relevancy: 'relevancy',
  groundTruth: 'groundTruth',
  confidence: 'confidence',
  reason: 'reason',
};

export const ISSUE_CODE_COLUMN_MAP: Record<string, string> = {
  issueCode: 'ISSUECODE',
  question: 'QUESTION',
  relevantDocCount: 'RELEVENCY',
  nonRelevantDocCount: 'NONRELEVENCY',
};

/** Grid field → API sortingColumn / columnFilter.columnName for view-by-docs. */
export const VIEW_BY_DOCS_COLUMN_MAP: Record<string, string> = {
  docId: 'DocId',
  flag: 'Flag',
  issueCodeMatchedCount: 'IssueCodeMatchedCount',
};

export const VIEW_BY_ISSUE_CODE_COLUMN_MAP: Record<string, string> = {
  reviewJobIssueCode: 'issueCode',
  question: 'question',
  relevantCount: 'relevantCount',
  nonRelevantCount: 'nonRelevantCount',
};

export const RELEVANCY_NAVIGATE_COLUMN_MAP: Record<string, string> = {
  relevancy: 'relevancy',
  groundTruth: 'groundTruth',
  confidence: 'confidence',
};

export const VIEW_BY_DOCS_NAVIGATE_COLUMN_MAP: Record<string, string> = {
  docId: 'docID',
};

/** Maps DataGrid header-filter items to the job-result list API columnFilter shape. */
export const mapGridFiltersToColumnFilters = (
  items: {field?: string; value?: unknown}[],
  columnMap: Record<string, string>
): {columnName: string; value: string}[] =>
  items
    .filter((item) => Boolean(item.field && columnMap[item.field]))
    .map((item) => ({
      columnName: columnMap[item.field as string],
      value: String(item.value ?? ''),
    }))
    .filter((item) => item.value.trim() !== '');

/** Maps header filters to POST …/navigate columnFilters ({columnName, filterValue}). */
export const mapGridFiltersToNavigateColumnFilters = (
  items: {field?: string; value?: unknown}[],
  columnMap: Record<string, string>
): {columnName: string; filterValue: string}[] =>
  mapGridFiltersToColumnFilters(items, columnMap).map(
    ({columnName, value}) => ({
      columnName,
      filterValue: value,
    })
  );

export interface IJobGroup {
  name: string;
  jobGroupId: number;
  count: number;
  isSelected: boolean;
}
